$(document).ready(function () {
  // --- Country Setup ---
  const countries = [
    { code: "AL", name: "Albania" }, { code: "AT", name: "Austria" }, { code: "AU", name: "Australia" },
    { code: "BY", name: "Belarus" }, { code: "BE", name: "Belgium" }, { code: "BA", name: "Bosnia and Herzegovina" },
    { code: "BG", name: "Bulgaria" }, { code: "CA", name: "Canada" }, { code: "CN", name: "China" },
    { code: "HR", name: "Croatia" }, { code: "CY", name: "Cyprus" }, { code: "CZ", name: "Czech" },
    { code: "DK", name: "Denmark" }, { code: "EE", name: "Estonia" }, { code: "FO", name: "Faroe Islands" },
    { code: "FI", name: "Finland" }, { code: "FR", name: "France" }, { code: "DE", name: "Germany" },
    { code: "GR", name: "Greece" }, { code: "GL", name: "Greenland" }, { code: "HK", name: "Hong Kong" },
    { code: "HU", name: "Hungary" }, { code: "IS", name: "Iceland" }, { code: "IE", name: "Ireland" },
    { code: "IT", name: "Italy" }, { code: "JP", name: "Japan" }, { code: "LV", name: "Latvia" },
    { code: "LI", name: "Liechtenstein" }, { code: "LT", name: "Lithuania" }, { code: "LU", name: "Luxembourg" },
    { code: "MO", name: "Macao" }, { code: "MY", name: "Malaysia" }, { code: "MC", name: "Monaco" },
    { code: "MT", name: "Malta" }, { code: "NL", name: "Netherlands" }, { code: "NO", name: "Norway" },
    { code: "PL", name: "Poland" }, { code: "PT", name: "Portugal" }, { code: "QA", name: "Qatar" },
    { code: "RO", name: "Romania" }, { code: "SA", name: "Saudi Arabia" }, { code: "RS", name: "Serbia" },
    { code: "SG", name: "Singapore" }, { code: "SK", name: "Slovakia" }, { code: "SI", name: "Slovenia" },
    { code: "ES", name: "Spain" }, { code: "SE", name: "Sweden" }, { code: "CH", name: "Switzerland" },
    { code: "TW", name: "Taiwan" }, { code: "TH", name: "Thailand" }, { code: "TR", name: "Turkey" },
    { code: "UA", name: "Ukraine" }, { code: "UAE", name: "United Arab Emirates" }, { code: "UK", name: "United Kingdom" },
    { code: "US", name: "United States" }, { code: "VA", name: "Vatican City" }, { code: "VN", name: "Vietnam" },
    { code: "REST", name: "Rest Of The World" },
  ];

  const getCookie = name => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : undefined;
  };

  const getCountryName = code => {
    const country = countries.find(c => c.code === (code || "").toUpperCase());
    return country ? country.name : "Rest Of The World";
  };

  let country = getCookie("country-origin");
  let countryName = getCountryName(country);

  if ($(`.progress_bar_values[data-country="${countryName}"]`).length === 0) {
    countryName = "Rest Of The World";
  }

  $(`.progress_bar_values[data-country="${countryName}"]`).addClass("current-country");
  $(`.upsell-main-container[data-country="${countryName}"]`).show().addClass("upsell-active");

  // --- Global discount update lock and cooldown ---
  let isCartUpdating = false;
  let cartUpdateCooldown = false;
  const CART_UPDATE_COOLDOWN_MS = 2000; // 1.2s, adjust as needed

  function startCartUpdateCooldown() {
    cartUpdateCooldown = true;
    setTimeout(() => {
      cartUpdateCooldown = false;
    }, CART_UPDATE_COOLDOWN_MS);
  }

  // --- Cart Watcher ---
  class CartWatcher {
    async fetchCart() {
      const response = await fetch("/cart.js");
      return response.json();
    }
    storeCart(cart) {
      localStorage.setItem("cart", JSON.stringify(cart));
    }
    storedCart() {
      return JSON.parse(localStorage.getItem("cart")) || { items: [] };
    }
    findCartChanges(oldCart, newCart) {
      const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
      let result = {
        added: onlyInLeft(newCart.items, oldCart.items),
        removed: onlyInLeft(oldCart.items, newCart.items),
      };
      oldCart.items.forEach(oi => {
        const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
        if (ni) {
          let quantity = ni.quantity - oi.quantity;
          let item = { ...ni, quantity: Math.abs(quantity) };
          quantity > 0 ? result.added.push(item) : result.removed.push(item);
        }
      });
      return result;
    }
    async emitCartChanges() {
      if (isCartUpdating || cartUpdateCooldown) return; // LOCK & COOLDOWN: Ignore updates during our own cart update
      const newCart = await this.fetchCart();
      const oldCart = this.storedCart();
      if (!areJSONsEqual(newCart, oldCart)) {
        window.dispatchEvent(new CustomEvent("cart_changed", { detail: newCart }));
      }
      this.storeCart(newCart);
    }
    observeCartChanges() {
      const observer = new PerformanceObserver(list => {
        list.getEntries().forEach(entry => {
          if (["xmlhttprequest", "fetch"].includes(entry.initiatorType) && /\/cart\//.test(entry.name)) {
            this.emitCartChanges();
          }
        });
      });
      observer.observe({ entryTypes: ["resource"] });
    }
    init() {
      this.emitCartChanges().then(() => this.observeCartChanges());
    }
  }

  const areJSONsEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

  const cartWatcher = new CartWatcher();
  cartWatcher.init();

  // --- Event Listener for Cart Changes ---
  window.addEventListener("cart_changed", function (e) {
    checkCart(e.detail);
    $(`#upsell-main-container[data-country="${countryName}"]`).load(
      `${location.href} #upsell-main-container[data-country="${countryName}"] > *`,
      "",
      function () {
        window.dispatchEvent(new CustomEvent("fetchUpsellItemsDate", { detail: { country: countryName } }));
        $(`.upsell-main-container[data-country="${countryName}"]`).show().addClass("upsell-active");
      }
    );
  });

  // --- Progress Bar Setup ---
  const symbol = $("body").data("currency_sym");
  const currentElem = $(".progress_bar_values.current-country");

  const tiers = {
    count: Number(currentElem.attr("data-tiers")),
    1: {
      threshold: Number(currentElem.attr("data-threshold1")),
      text: currentElem.attr("data-threshold1text"),
      code: currentElem.attr("data-threshold1code"),
      before: currentElem.attr("data-beforetier1")
    },
    2: {
      threshold: Number(currentElem.attr("data-threshold2")),
      text: currentElem.attr("data-threshold2text"),
      code: currentElem.attr("data-threshold2code"),
      before: currentElem.attr("data-beforetier2")
    },
    3: {
      threshold: Number(currentElem.attr("data-threshold3")),
      text: currentElem.attr("data-threshold3text"),
      code: currentElem.attr("data-threshold3code"),
      before: currentElem.attr("data-beforetier3")
    },
    completedText: currentElem.attr("data-completedtext"),
  };

  // Append progress bar thresholds
  const appendThreshold = (num, left) => {
    $(".progress-bar-container").append(
      `<div class="threshold threshold-${num}" style="left: ${left}%;">
        <span class="price">${Shopify.formatMoney(tiers[num].threshold, symbol + "{{amount}}")}</span>
        <span class="main"></span>
        <span class="discount">${tiers[num].text}</span>
      </div>`
    );
  };

  if (tiers.count === 1) {
    appendThreshold(1, 50);
  } else if (tiers.count === 2) {
    appendThreshold(1, 25);
    appendThreshold(2, 75);
  } else if (tiers.count === 3) {
    appendThreshold(1, 25);
    appendThreshold(2, 50);
    appendThreshold(3, 75);
  }

  // --- Discount Helpers ---
  function getCurrentCartDiscounts(cart) {
    return (cart.discount_codes || []).map(d => (d.code || '').toLowerCase());
  }

  function applyDiscountIfNeeded(cart, code) {
    const current = getCurrentCartDiscounts(cart);
    if (!code) return;
    if (current.includes(code.toLowerCase())) return; // Already applied
    $(".cart-loader-full").show();
    applyDiscount(code);
  }

  function clearDiscountIfNeeded(cart) {
    const current = getCurrentCartDiscounts(cart);
    if (!current.length) return; // Nothing to clear
    $(".cart-loader-full").show();
    clearDiscount();
  }

  function applyDiscount(code) {
    isCartUpdating = true;
    startCartUpdateCooldown();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
    .then(response => response.json())
    .then(() => {
      isCartUpdating = false;
      document.dispatchEvent(new Event('cart:build'));
      setTimeout(function(){
         $(".cart-loader-full").hide(); 
      },1000)
      
    })
    .catch(error => {
      isCartUpdating = false;
      console.error(error);
    });
  }

  function clearDiscount() {
    localStorage.removeItem('discountCode');
    isCartUpdating = true;
    startCartUpdateCooldown();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    })
    .then(response => response.json())
    .then(() => {
      isCartUpdating = false;
      document.dispatchEvent(new Event('cart:build'));
      setTimeout(function(){
         $(".cart-loader-full").hide(); 
      },1000)
    })
    .catch(error => {
      isCartUpdating = false;
      console.error(error);
    });
  }

  // --- Cart Check/Discount Functions ---
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    success: checkCart,
  });

  function checkCart(cartdata) {
    let { count, 1: tier1, 2: tier2, 3: tier3, completedText } = tiers;
    let otPrice = cartdata.original_total_price;
    let showProgress = otPrice > 0;

    if (!showProgress) {
      $(".cart-discount-progress").hide();
      return;
    }
    $(".cart-discount-progress").show();

    if (count === 1) {
      if (otPrice < tier1.threshold) {
        $(".cart-discount-progress .text-code").html(
          tier1.before.replace("{{amount_left}}", tier1.threshold - otPrice)
        );
        clearDiscountIfNeeded(cartdata);
        $(".progress-bar").find("#progress").css("width", "40%");
      } else {
        $(".cart-discount-progress .text-code").html(completedText);
        applyDiscountIfNeeded(cartdata, tier1.code);
        $(".progress-bar").find("#progress").css("width", "100%");
      }
    } else if (count === 2) {
      if (otPrice < tier1.threshold) {
        $(".cart-discount-progress .text-code").html(
          tier1.before.replace("{{amount_left}}", Shopify.formatMoney(tier1.threshold - otPrice, symbol + "{{amount}}"))
        );
        clearDiscountIfNeeded(cartdata);
        $(".progress-bar").find("#progress").css("width", "23%");
      } else if (otPrice >= tier1.threshold && otPrice <= tier2.threshold) {
        $(".cart-discount-progress .text-code").html(
          tier2.before.replace("{{amount_left}}", Shopify.formatMoney(tier2.threshold - otPrice, symbol + "{{amount}}"))
        );
        applyDiscountIfNeeded(cartdata, tier1.code);
        $(".progress-bar").find("#progress").css("width", "45%");
      } else {
        $(".cart-discount-progress .text-code").html(completedText);
        applyDiscountIfNeeded(cartdata, tier2.code);
        $(".progress-bar").find("#progress").css("width", "100%");
      }
    } else if (count === 3) {
      if (otPrice < tier1.threshold) {
        $(".cart-discount-progress .text-code").html(
          tier1.before.replace("{{amount_left}}", Shopify.formatMoney(tier1.threshold - otPrice, symbol + "{{amount}}"))
        );
        clearDiscountIfNeeded(cartdata);
        $(".progress-bar").find("#progress").css("width", "23%");
      } else if (otPrice >= tier1.threshold && otPrice <= tier2.threshold) {
        $(".cart-discount-progress .text-code").html(
          tier2.before.replace("{{amount_left}}", Shopify.formatMoney(tier2.threshold - otPrice, symbol + "{{amount}}"))
        );
        applyDiscountIfNeeded(cartdata, tier1.code);
        $(".progress-bar").find("#progress").css("width", "45%");
      } else if (otPrice >= tier2.threshold && otPrice <= tier3.threshold) {
        $(".cart-discount-progress .text-code").html(
          tier3.before.replace("{{amount_left}}", Shopify.formatMoney(tier3.threshold - otPrice, symbol + "{{amount}}"))
        );
        applyDiscountIfNeeded(cartdata, tier3.code);
        $(".progress-bar").find("#progress").css("width", "67%");
      } else {
        $(".cart-discount-progress .text-code").html(completedText);
        applyDiscountIfNeeded(cartdata, tier3.code);
        $(".progress-bar").find("#progress").css("width", "100%");
      }
    }
  }
});
